import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { Icon } from '@iconify/react'

// antd
import { Form, Input, Typography } from 'antd'

// slices
import { passwordReset } from './login.slice'

// routes
import { PUBLIC_ROUTES } from '../../routes'

// components
import Button from '../../components/button/button'

// constants
import { FORM_VALIDATION_RULES } from '../../constants/validationRules/form'

// assets
import logo from '../../assets/images/logo.png'

// icons
import { EyeIcon, EyeSlashIcon } from '../../assets/icons/login/PasswordIcons'

// css
import './LoginForm.css'
import { showActionNotification } from '../../components/notification'

function SetPassword() {
    const [form] = Form.useForm()
    const { Text } = Typography

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useLocation()

    const json = Object.fromEntries(new URLSearchParams(params.search))
    const [loadingButton, setLoadingButton] = useState(false)

    // UPDATE PASSWORD
    async function onUpdatePassword(values) {
        setLoadingButton(true)

        const result = await dispatch(
            passwordReset({
                token: json.token,
                userId: json.userId,
                newPassword: values.password,
            })
        )

        const data = result?.payload?.data
        setLoadingButton(false)

        if (!data) {
            showActionNotification({
                type: 'error',
                message: 'Something went wrong',
            })
            return
        }

        if (data.success) {
            showActionNotification({
                type: 'success',
                message: data.message,
            })
            navigate(PUBLIC_ROUTES.successfullyResetPassword)
        } else {
            showActionNotification({
                type: 'error',
                message: data.message || 'Something went wrong',
            })
        }
    }

    return (
        <div className="glass-card">
            <div className="login-logo-container">
                <img src={logo} alt="logo" className="login-form-logo-img" />
            </div>

            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginBottom: 24,
                }}
            >
                <Text
                    style={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        fontSize: 14,
                    }}
                    onClick={() => navigate(PUBLIC_ROUTES.login)}
                >
                    <Icon icon="mdi:arrow-left" width={20} height={20} />
                    Back to sign in
                </Text>
            </div>

            <h2 className="welcome-title">Set Password</h2>
            <p className="welcome-subtitle">
                Create a strong password to secure your account.
            </p>

            <Form
                layout="vertical"
                form={form}
                onFinish={onUpdatePassword}
                requiredMark={false}
                autoComplete="off"
                className="custom-login-form"
                style={{
                    rowGap: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* NEW PASSWORD */}
                <Form.Item
                    label="New Password"
                    name="password"
                    rules={[
                        FORM_VALIDATION_RULES.password.required,
                        FORM_VALIDATION_RULES.password.minLength8,
                        FORM_VALIDATION_RULES.password.includeUpperLowerNumber,
                    ]}
                >
                    <Input.Password
                        className="custom-input"
                        placeholder="Enter new password"
                        autoComplete="new-password"
                        iconRender={(visible) =>
                            visible ? (
                                <div
                                    onClick={() => {}}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <EyeIcon />
                                </div>
                            ) : (
                                <div
                                    onClick={() => {}}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <EyeSlashIcon />
                                </div>
                            )
                        }
                    />
                </Form.Item>

                {/* CONFIRM PASSWORD */}
                <Form.Item
                    label="Confirm Password"
                    name="passwordConfirm"
                    dependencies={['password']}
                    rules={FORM_VALIDATION_RULES.password.confirm()}
                >
                    <Input.Password
                        className="custom-input"
                        placeholder="Confirm password"
                        autoComplete="new-password"
                        iconRender={(visible) =>
                            visible ? (
                                <div
                                    onClick={() => {}}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <EyeIcon />
                                </div>
                            ) : (
                                <div
                                    onClick={() => {}}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <EyeSlashIcon />
                                </div>
                            )
                        }
                    />
                </Form.Item>

                <Button
                    props={{
                        text: 'Set Password',
                        htmlType: 'submit',
                        className: 'login-submit-btn',
                        loadingButton,
                        disabled: loadingButton,
                    }}
                />
            </Form>
        </div>
    )
}

export default SetPassword
